import * as React from 'react'
import { FieldError } from 'react-hook-form'

import { cn } from '../../utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string
  inputClassName?: string
  type?: 'text' | 'password' | 'email' | 'number' | 'search' | 'tel' | 'url'
  icon?: React.ReactNode
  error?: FieldError
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type = 'text',
      icon,
      error,
      inputClassName,
      disabled,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={cn('relative w-full', className)}>
        {icon && (
          <div className='absolute left-[11px] top-1/2 -translate-y-1/2 transform'>
            {icon}
          </div>
        )}
        <input
          type={type}
          className={cn(
            'border-input flex h-10 w-full rounded-md border border-solid border-grey-500 bg-transparent px-3 py-2 pl-10 text-sm ring-offset-background placeholder:text-grey-600 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            '[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none', // Remove number input arrows
            icon ? 'pl-10' : 'pl-3',
            error ? 'border-red-500' : '',
            inputClassName,
            disabled && 'bg-grey-500',
          )}
          ref={ref}
          disabled={disabled}
          {...props}
        />
      </div>
    )
  },
)

Input.displayName = 'Input'

export { Input }
